import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

import { BackgroundColorProp } from '.';

type StyleProps = {
  backgroundColor: BackgroundColorProp;
};

const useStyles = createUseStyles(
  ({
    brandColors: { background },
    breakpoints: { md },
    type: {
      fontSize: { body, cardTitle },
      fontWeight,
    },
  }: CmsWrenchTheme) => {
    const mediaQueryMinScreenMD = `@media (min-width: ${md}px)`;

    return {
      container: ({ backgroundColor }: StyleProps) => ({
        backgroundColor: background[backgroundColor],
      }),
      headingText: {
        fontWeight: fontWeight.medium,
      },
      subheadingText: {
        [mediaQueryMinScreenMD]: {
          fontSize: typeof body === 'number' ? body * 1.125 : body,
        },
      },
    };
  }
);

export default useStyles;
